const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsCube = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 16.5,
    x: 1.6,
    y: 5.7,
    style: {
      fill: "none",
      stroke: "#00a000",
      strokeWidth: 2
    },
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.7 6 5-3.9a2 2 0 0 1 1-.2h11.5c1.2 0 2.2 1 2.2 2.2v10.6c0 1-.7 2-1.2 2.4l-3.5 4",
    style: {
      fill: "none",
      stroke: "#00a000",
      strokeWidth: 2,
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.5 6.3 4.3-3.7",
    style: {
      fill: "none",
      stroke: "#00a000",
      strokeWidth: 2
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsCube);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icons_cube_.5170a73387aed5d1818d3a6c20c5ece5.svg";